import { memo } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { clsx } from 'clsx';
import { Button } from '../buttons';
import styles from './TableHeaderCell.module.scss';
import SortIndicator from './SortIndicator';

export interface TableHeaderCellProps {
    children?: ReactNode;
    /**
     * Make cell as sortable
     */
    sortable?: boolean;
    /**
     * The current sort order
     */
    sortOrder?: 'desc' | 'asc';
    /**
     * Sort change callback
     */
    onSortChange?: (order: 'desc' | 'asc') => void;
    /**
     * The width of the cell
     */
    width?: CSSProperties['width'];
}

const TableHeaderCell = ({
    children,
    sortable,
    sortOrder,
    onSortChange,
    width,
}: TableHeaderCellProps) => {
    if (sortable) {
        return (
            <th
                className={clsx(styles.tableHeaderItem, {
                    [styles.sortable]: sortable,
                })}
            >
                <Button
                    text
                    inline
                    secondary
                    onClick={() => {
                        if (sortOrder === 'desc') {
                            onSortChange?.('asc');
                        } else {
                            onSortChange?.('desc');
                        }
                    }}
                >
                    <div className={styles.buttonContent}>{children}</div>
                    {sortOrder && <SortIndicator asc={sortOrder === 'asc'} />}
                </Button>
            </th>
        );
    }
    return (
        <th
            className={styles.tableHeaderItem}
            style={{
                width,
            }}
        >
            {children}
        </th>
    );
};

export default memo(TableHeaderCell);
